import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentDialogService} from "../../services/agent-dialogs-service.service";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentModel} from "../../angular/models/agent.model";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class AgentRequirementViewCtrl implements IController {

  agent: AgentModel;
  loading: boolean;
  requirement: any;
  selectedVehicle: any;

  constructor(private agentConstants, private confirmDialogService: ConfirmDialogService, private agentDialogService: AgentDialogService,
              private $log, private agentRequests: AgentRequests) {
  }

  $onInit() {
  }

  rejectedRequirement(event) {
    const requirementCopy = angular.copy(this.requirement);

    this.agentDialogService.declineRequirement(event)
      .then((data) => {
        if (data) {
          requirementCopy.status = 'Rejected';
          requirementCopy.message = data.message;
          this._doUpdate(requirementCopy, data.sendSms, data.sendEmail);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  approveRequirement(event) {
    const requirementCopy = angular.copy(this.requirement);

    this.confirmDialogService.confirm('Approve Requirement', 'Are you sure you want to approve this requirement?', event)
      .then(() => {
        requirementCopy.status = 'Approved';
        this._doUpdate(requirementCopy);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  changeRequirementStatus(event, approveState) {

    const requirementCopy = angular.copy(this.requirement);
    const status = this.agentConstants.requirementApproveState[approveState];

    // Approved Requirement
    if (_.isEqual(approveState, 'Approved')) {
      this.confirmDialogService.confirm('Approve Requirement', 'Are you sure you want to approve this requirement?', event)
        .then(() => {
          requirementCopy.status = status;
          this._doUpdate(requirementCopy);
        })
        .catch(() => {
          this.$log.info('Dialog Closed')
        })
    }
    // Declined Requirement
    else {
      this.agentDialogService.declineRequirement(event)
        .then((data) => {
          if (data) {
            requirementCopy.status = status;
            requirementCopy.message = data.message;
            this._doUpdate(requirementCopy, data.sendSms, data.sendEmail);
          }
        })
        .catch(() => {
          this.$log.info('Dialog Closed')
        })
    }

  }

  editRequirement(event) {
    const approveStatus = this.agentConstants.requirementApproveState.Approved;
    this.agentDialogService.editRequirement(event, this.requirement, this.agent, approveStatus)
      .then((updatedRequirement) => {
        if (updatedRequirement) {
          this.requirement = updatedRequirement;
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })

  }

  showDriverInfo() {
    return ['AgentLicenseData', 'InspectionData', 'DrivingHistoryReportData'].indexOf(_.get(this.requirement, 'data.type')) > -1;
  }

  showVehicleInfo() {
    return ['LicensePlateData', 'InsuranceData', 'InspectionData', 'VehicleRegistrationData'].indexOf(_.get(this.requirement, 'data.type')) > -1;
  }


  private _doUpdate(requirementCopy, sendSms?, sendEmail?) {
    this.loading = true;
    this.agentRequests.postRequirements(this.agent.id, requirementCopy, sendSms, sendEmail)
      .then((updatedRequirement) => {
        this.loading = false;
        if (updatedRequirement) {
          this.requirement = updatedRequirement;
        }
      })
      .catch((error) => {
        this.$log.error('Failed to update requirement', error)
      })
      .finally(() => {
        this.loading = false;
      })


  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentRequirementView', {
    bindings: {
      agent: '<',
      loading: '<',
      requirement: '<',
      selectedVehicle: '<'
    },
    template: require('./agent-requirement-view.html').default,
    controller: AgentRequirementViewCtrl
  });
